export default __webpack_public_path__ + "static/media/logo_original_small.921a76e3.xcf";